import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const CloudDownloadIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.47045 9.78685C5.96431 7.54256 7.42543 5.65519 9.43792 4.70081C12.8863 3.06422 16.9245 4.58887 18.6177 8.10526C21.6017 8.17438 24 10.7419 24 13.8997C24 17.101 21.5352 19.6956 18.4942 19.6956L4.61957 19.6955C4.23455 19.6849 3.85178 19.6253 3.47645 19.5177C0.955481 18.7845 -0.5237 16.04 0.171753 13.3859C0.819816 10.9166 3.12276 9.39621 5.47045 9.78685ZM4.63432 18.6434H18.4959C20.9847 18.6434 23.0018 16.52 23.0018 13.9001C23.0018 11.2802 20.9847 9.15689 18.4959 9.15689H18.3039C18.1073 9.15689 17.929 9.03564 17.8482 8.84701C16.4747 5.64232 12.8948 4.21609 9.85054 5.66091C7.98504 6.54558 6.67172 8.36456 6.36046 10.4948C6.31497 10.8062 6.02159 11.006 5.73314 10.9221C3.74465 10.3438 1.68689 11.5728 1.13742 13.6664C0.588834 15.76 1.75569 17.925 3.74278 18.5029C4.03938 18.588 4.34264 18.6352 4.63432 18.6434Z'
        />
        <path d='M13.002 15.7071L17.127 10.8285C17.3097 10.6124 17.6257 10.5918 17.8327 10.7825C18.0398 10.9731 18.0596 11.3028 17.8769 11.5189L12.8769 17.4323C12.6818 17.663 12.3388 17.6684 12.1372 17.4439L7.13716 11.878C6.94831 11.6678 6.95854 11.3376 7.16001 11.1405C7.36147 10.9435 7.67789 10.9541 7.86674 11.1644L12.002 15.7676L12.002 4.56535C12.502 4.56535 12.502 4.56535 12.502 4.56535L13.002 4.56535L13.002 15.7071Z' />
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
